import type { TrainingLessonSpecific } from './trainingLessonUi';

export const deacon2ServiceEs: TrainingLessonSpecific = {
  intro:
    'El oficio de diácono se ejerce principalmente mediante el servicio. En esta lección aprenderás a servir con iniciativa, humildad y trabajo en equipo, sin buscar reconocimiento.',
  objectives: [
    'Entender que el servicio es la forma principal de ejercer el oficio de diácono.',
    'Aprender a servir sin llamar la atención y sin esperar reconocimiento.',
    'Desarrollar iniciativa: ver necesidades y actuar con permiso y orden.',
    'Practicar respeto, reverencia y trabajo en equipo con otros poseedores del sacerdocio.',
    'Crear un plan simple de servicio semanal (en casa + en la Iglesia).',
  ],
  briefHeading: 'El servicio como diácono en breve',
  briefBody:
    'Un diácono confiable ve necesidades y actúa con permiso y orden. Sirve sin llamar la atención, trabaja en equipo con otros poseedores del sacerdocio, y crea un plan semanal de servicio en casa y en la Iglesia. El oficio se trata de cargar con otros, no de lucirse.',
  scriptures: [
    {
      ref: 'Mosíah 2:17',
      text: 'Cuando os halláis al servicio de vuestros semejantes, solo estáis al servicio de vuestro Dios.',
    },
    { ref: 'DyC 58:26–28', text: 'No conviene que sean compelidos... ser anxiously engaged en una buena causa.' },
    { ref: 'Mateo 20:26–28', text: 'El que quiera ser el mayor entre vosotros, sea vuestro servidor.' },
    { ref: 'Alma 37:6–7', text: 'Por cosas pequeñas se realizan grandes cosas.' },
    { ref: 'DyC 84:106', text: 'Fortalecer a los débiles, levantar las manos caídas.' },
  ],
  didYouKnow: [
    'El servicio "silencioso" es entrenamiento espiritual: te enseña a actuar por amor, no por aplausos.',
    'La iniciativa no es desorden: un diácono con iniciativa pregunta, coordina y actúa con humildad.',
  ],
  practiceItems: [
    'Hacer una lista de 3 necesidades que veo en casa o en la Iglesia',
    'Elegir 1 necesidad y hacer un plan simple: qué haré, cuándo, y con quién debo coordinar',
    'Preguntar a un líder (papá/obispo/presidencia/quórum) si puedo ayudar en X cosa',
    'Servir sin anunciarlo (sin post ni comentario; solo hacerlo)',
    'Practicar "trabajo en equipo": ayudar a otro diácono a hacer su parte, sin mandarlo',
    'Al final del día, escribir una línea: "Hoy serví en ____ y me sentí ____."',
  ],
  reflectionQuestions: [
    '¿Qué me impide servir más: pereza, vergüenza, distracción o orgullo?',
    '¿A quién se le haría la vida más fácil si yo sirviera mejor esta semana?',
    '¿Cómo puedo mostrar reverencia mientras sirvo (sin prisa, sin relajo)?',
  ],
  actionText:
    'Servicio semanal fijo: elige una acción que harás todas las semanas (ej.: recoger, ayudar a un hermano mayor, preparar cosas del domingo, ayudar a mamá/papá sin que lo pidan).',
};
